module.exports = __webpack_public_path__ + "static/img/5.c2d4ffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/5.png
// module id = IT7F
// module chunks = 0